module.exports = __webpack_public_path__ + "pdf/sustainability.90a8d8c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/sustainability.pdf
// module id = UU+S
// module chunks = 0